import moment from 'moment'
import { DATE_SHOW_FORMAT } from "@/utils/config";

export function generateStaticDay(dates, id = 0) {
  return {
    content: true,
    highlight: {
      class: 'mini-calendar-day-highlight',
      fillMode: 'outline',
    },
    dates: dates,
    id
  }
}

export function generateDatefromFilter(selected) {
  let start, end;
  if (selected == "today") {
    start = moment();
    return start.format(DATE_SHOW_FORMAT);
  } else if (selected == "tomorrow") {
      start = moment().add(1,'days');
      return start.format(DATE_SHOW_FORMAT);
  } else if (selected == "week") {
      start = moment().startOf("week");
      end = moment().endOf('week');
  } else if (selected == "month") {
      start = moment().startOf("month");
      end = moment().endOf("month");
  } else {
    return '';
  }

  return start.format(DATE_SHOW_FORMAT) + ' to ' + end.format(DATE_SHOW_FORMAT)
}

export function get_available_taxonomy(filtered = true) {
  const result = [];
  let taxonomy = window.drupalSettings.idfive_calendar_client.options.taxonomy;
  if (taxonomy) {
    Object.keys(taxonomy).forEach((item) => {
      if (taxonomy[item]) {
        result.push(item);
      }
    });
  }

  if (filtered && window.drupalSettings.idfive_calendar_client.options.filtered_taxonomy) {
    result.push(window.drupalSettings.idfive_calendar_client.options.filtered_taxonomy.trim())
  }

  return result;
}

export function get_available_category() {
  if (window.drupalSettings.idfive_calendar_client.options.category) {
    return window.drupalSettings.idfive_calendar_client.options.category.trim().split(",");
  }

  return [];
}
// export function get_term_ids_by_taxonomy(query) {

// }